import ReactModal from 'react-modal';
import styled from '@emotion/styled';
import { ClassNames } from '@emotion/react';
import { ReactSVG } from 'react-svg';
import hstatic from '../../../helper/hstatic';
import staticHypotheekbondUrl from '../../../helper/staticHypotheekbondUrl';

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;

  width: 20px;
  height: 20px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    top: 32px;
    right: 32px;
  }

  svg {
    display: block;
    height: 20px;
    width: 20px;
    fill: #979797;
  }
`;

const StyledModalComponent = ({ children, maxWidth, showCross, overflowY, ...props }) => (
  <ClassNames>
    {({ css }) => (
      <ReactModal
        {...props}
        appElement={props.appElement || document.body.children[0]}
        portalClassName="react-modal"
        bodyOpenClassName={css`
          > div:not(.react-modal) {
            filter: blur(3px);
          }
        `}
        overlayClassName={css`
          position: fixed;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 0px;
          background-color: rgba(255, 255, 255, 0.75);
          @supports (filter: blur()) {
            background-color: rgba(0, 0, 0, 0);
          }

          z-index: 9999;
        `}
        className={css`
          position: fixed;
          top: 50%;
          right: auto;
          bottom: auto;
          left: 50%;

          transform: translate(-50%, -50%);

          max-height: 80%;
          width: 85%;
          max-width: ${maxWidth ? `${maxWidth}px` : null};

          border: 1px solid #cccccc;
          
          font-size: 14px;
          line-height: 24px;
          
          p {
            margin-bottom:  16px;
          }

          @supports (filter: blur()) {
            border: none;
          }
          border-radius: 10px;
          box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
          background: #ffffff;

          padding: 16px;

          overflow-y: ${overflowY ? overflowY : 'auto'};
          outline: none;

          @media screen and (min-width: 768px) {
            width: 80%;
            padding: 32px;
          }
        `}
      >
        {showCross && (
          <CloseButton type="button" onClick={props.onRequestClose}>
            <ReactSVG src={hstatic(`${staticHypotheekbondUrl()}/images/icon/cross.svg`)} />
          </CloseButton>
        )}
        {children}
      </ReactModal>
    )}
  </ClassNames>
);

StyledModalComponent.defaultProps = {
  ...ReactModal.defaultProps,
  showCross: true,
};

export default StyledModalComponent;
